import React, { useContext } from "react";

import {
  Context,
  textbookPath,
  chooseTextbookPath,
} from "../../../teacherStore";
import SelectTextbook from "../../../templates/Select/Textbook";

export default () => {
  const { state } = useContext(Context);

  return (
    <SelectTextbook
      basicPath={`${textbookPath}${chooseTextbookPath}`}
      activeLearningPath={`${textbookPath}${chooseTextbookPath}?isActiveLearning=true`}
      has_base={state.has_base}
    />
  );
};
